import {Toast} from "react-native-toast-message/lib/src/Toast";
import {Network} from "../../../utils/network";

export const mobilesignInReact = async (
  response,
  profileSet,
  isUserCall = null,
  errorCallBack
) => {
  const userInfo1 = response?.credential;
  let reqObj = {
    token: userInfo1,
  };
  let res;
  if (isUserCall) {
    res = await isUserCall(null, null, null, null, reqObj);
  } else {
    res = await Network.verifyGoogleEmail(reqObj, true);
  }

  if (res?.data?.success) {
    profileSet(res?.data);
  } else {
    const error = res?.data?.msg || "Error";
    // customToast(error);
    if (errorCallBack) {
      errorCallBack(error);
    }
    Toast.show({
      autoHide: true,
      visibilityTime: 1000,
      position: "bottom",
      type: "error",
      text1: error,
      bottomOffset: 20,
    });
  }
};
